import GestionGastos from "./GestionGastos";
export default GestionGastos;